import React from "react";
import { STATUS_COLORS } from "../utils/constants";

/**
 * AssetList component displays all engines with their current status.
 * Allows selection of an asset for detailed view.
 */
export function AssetList({ assets, selectedAsset, onSelectAsset }) {
  // Sort assets by ID
  const sortedAssets = Object.values(assets).sort(
    (a, b) => a.asset_id - b.asset_id
  );

  // Count by status
  const statusCounts = sortedAssets.reduce(
    (acc, asset) => {
      acc[asset.status] = (acc[asset.status] || 0) + 1;
      return acc;
    },
    { OK: 0, WARNING: 0, ALERT: 0, INIT: 0, WARMING: 0 }
  );

  return (
    <div className="asset-list">
      <div className="asset-list-header">
        <h2>Engine Fleet</h2>
        <div className="status-summary">
          {(statusCounts.INIT + statusCounts.WARMING) > 0 && (
            <span className="status-badge warming">
              {statusCounts.INIT + statusCounts.WARMING} Warming
            </span>
          )}
          <span className="status-badge ok">{statusCounts.OK} OK</span>
          <span className="status-badge warning">{statusCounts.WARNING} Warn</span>
          <span className="status-badge alert">{statusCounts.ALERT} Alert</span>
        </div>
      </div>

      <div className="asset-list-scroll">
        {sortedAssets.length === 0 ? (
          <div className="no-assets">
            <p>Waiting for data...</p>
            <p className="hint">Start the producer to see engines</p>
          </div>
        ) : (
          sortedAssets.map((asset) => (
            <div
              key={asset.asset_id}
              className={`asset-item ${
                selectedAsset === asset.asset_id ? "selected" : ""
              } status-${asset.status.toLowerCase()}`}
              onClick={() => onSelectAsset(asset.asset_id)}
            >
              <div className="asset-info">
                <span className="asset-id">Engine {asset.asset_id}</span>
                <span className="asset-cycle">Cycle {asset.last_cycle}</span>
              </div>

              <div className="asset-status">
                <span
                  className={`status-dot-indicator ${asset.status.toLowerCase()}`}
                  style={{ backgroundColor: STATUS_COLORS[asset.status] }}
                />

                {asset.risk && (
                  <span
                    className="risk-badge"
                    style={{
                      backgroundColor: getRiskColor(asset.risk.risk_score),
                    }}
                  >
                    {(asset.risk.risk_score * 100).toFixed(0)}%
                  </span>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

function getRiskColor(score) {
  if (score >= 0.7) return STATUS_COLORS.ALERT;
  if (score >= 0.5) return STATUS_COLORS.WARNING;
  return STATUS_COLORS.OK;
}
